// extracted by mini-css-extract-plugin
module.exports = {"mainwell":"layout-module--mainwell--14RbA"};